import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import product from './modules/product'
import auth from './modules/auth'
import cart from './modules/cart'
import category from './modules/category'
import dealer from './modules/dealer'
import make from './modules/make'
import model from './modules/model'
import term from './modules/term'
import trim from './modules/trim'
import year from './modules/year'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
  },
  modules: {
    auth: auth,
    cart: cart,
    categories: category,
    dealers: dealer,
    makes: make,
    models: model,
    products: product,
    terms: term,
    trims: trim,
    years: year
  },
  plugins: [
    createPersistedState({
      paths: ['cart', 'dealers', 'trims', 'models', 'makes', 'terms', 'years']
    })
  ] 
})